var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagFrance(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  props = _objectSpread({
    title: ''
  }, props);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "flagFrance_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 640,
    height: 478
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 640,
    height: 478,
    rx: 40,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagFrance_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v480H0V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h213.3v480H0V0Z",
    fill: "#00267F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7 0H640v480H426.7V0Z",
    fill: "#F31830"
  }))));
}
export { SvgFlagFrance as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQwIDQ4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48bWFzayBpZD0iYSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMiIgd2lkdGg9IjY0MCIgaGVpZ2h0PSI0NzgiPjxyZWN0IHk9IjIiIHdpZHRoPSI2NDAiIGhlaWdodD0iNDc4IiByeD0iNDAiIGZpbGw9IiNDNEM0QzQiLz48L21hc2s+PGcgbWFzaz0idXJsKCNhKSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjQwdjQ4MEgwVjBaIiBmaWxsPSIjZmZmIi8+PHBhdGggZD0iTTAgMGgyMTMuM3Y0ODBIMFYwWiIgZmlsbD0iIzAwMjY3RiIvPjxwYXRoIGQ9Ik00MjYuNyAwSDY0MHY0ODBINDI2LjdWMFoiIGZpbGw9IiNGMzE4MzAiLz48L2c+PC9zdmc+Cg==";